<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <HelpTooltip>
    <div
      class="m-1 grid grid-cols-2 items-center justify-end gap-2 text-start text-xs text-gray-200"
    >
      <div class="inline-flex items-center gap-x-2">
        <UKbd>↑</UKbd>
        <span>{{ t("globalsearch.shortcut.or") }}</span>
        <span class="inline-flex items-center gap-x-1">
          <UKbd>ctrl</UKbd>
          <UKbd>p</UKbd>
        </span>
      </div>
      <span>{{ t("globalsearch.shortcut.nagivate_up") }}</span>

      <div class="inline-flex items-center gap-x-2">
        <UKbd>↓</UKbd>
        <span>{{ t("globalsearch.shortcut.or") }}</span>
        <span class="inline-flex items-center gap-x-1">
          <UKbd>ctrl</UKbd>
          <UKbd>n</UKbd>
        </span>
      </div>
      <span>{{ t("globalsearch.shortcut.nagivate_down") }}</span>

      <div class="inline-flex items-center gap-x-2 justify-self-center">
        <UKbd>enter</UKbd>
      </div>
      <span>{{ t("globalsearch.shortcut.select") }}</span>

      <div class="inline-flex items-center gap-x-2 justify-self-center">
        <UKbd>esc</UKbd>
      </div>
      <span>{{ t("globalsearch.shortcut.close") }}</span>
    </div>
  </HelpTooltip>
</template>
